import apiClient from './client';

export interface HubLeader {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
}

export interface Hub {
  id: number;
  name: string;
  hubLeaderId?: number;
  description?: string;
  isActive: boolean;
  centerLatitude?: number | null;
  centerLongitude?: number | null;
  regionGeoJson?: { type: 'Polygon' | 'MultiPolygon'; coordinates: any } | null;
  hubLeader?: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
  };
  planterCount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface HubFilters {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
}

export interface CreateHubData {
  name: string;
  hubLeaderId?: number;
  description?: string;
  isActive?: boolean;
  centerLatitude?: number | null;
  centerLongitude?: number | null;
  regionGeoJson?: { type: 'Polygon' | 'MultiPolygon'; coordinates: any } | null;
}

export interface UpdateHubData {
  name?: string;
  hubLeaderId?: number | null;
  description?: string;
  isActive?: boolean;
  centerLatitude?: number | null;
  centerLongitude?: number | null;
  regionGeoJson?: { type: 'Polygon' | 'MultiPolygon'; coordinates: any } | null;
}

class HubService {
  async getAllHubs(filters?: HubFilters) {
    const params = new URLSearchParams();
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.limit) params.append('limit', filters.limit.toString());
    if (filters?.search) params.append('search', filters.search);
    if (filters?.isActive !== undefined) params.append('isActive', filters.isActive.toString());

    const response = await apiClient.get(`/hubs?${params.toString()}`);
    return response.data;
  }

  async getHub(id: number) {
    const response = await apiClient.get(`/hubs/${id}`);
    return response.data;
  }

  async createHub(data: CreateHubData) {
    const response = await apiClient.post('/hubs', data);
    return response.data;
  }

  async updateHub(id: number, data: UpdateHubData) {
    const response = await apiClient.put(`/hubs/${id}`, data);
    return response.data;
  }

  async deleteHub(id: number) {
    const response = await apiClient.delete(`/hubs/${id}`);
    return response.data;
  }
}

export const hubService = new HubService();
